import clsx from 'clsx';
import { makeStyles } from '@material-ui/core';
import { darken, lighten, alpha } from '@material-ui/core/styles/colorManipulator';

const labelWidth = 235;

const useStyles = makeStyles((theme) => ({
    fixedLabelContainer: {
        '& .fixed-label-row': {
            ...theme.mixins.flex.displayFlex,
            ...theme.mixins.flex.flexDirectionRow,
            ...theme.mixins.flex.grow(1),
            ...theme.mixins.flex.shrink(1),
            paddingTop: theme.spacing(1),
        },
        '& .fixed-label-label': {
            width: labelWidth,
            minWidth: labelWidth,
            fontWeight: 500,
            lineHeight: '24px',
            height: '24px',
        },
        '& .fixed-label-content': {
            ...theme.mixins.flex.grow(1),
            ...theme.mixins.flex.shrink(1),
            minWidth: 0,
            width: 0,
        },
        '& .fixed-label-divider': {
            height: 1,
            width: '100%',
            backgroundColor:
                theme.palette.type === 'light'
                    ? lighten(alpha(theme.palette.divider, 1), 0.85)
                    : darken(alpha(theme.palette.divider, 1), 0.85),
        },
    },
}));

export const Row = ({ className, children }) => <div className={clsx('fixed-label-row', className)}>{children}</div>;

export const Label = ({ children }) => {
    return <div className="fixed-label-label">{children}</div>;
};

export const Content = ({ children }) => <div className="fixed-label-content">{children}</div>;

export const Line = () => (
    <Row>
        <div className="fixed-label-divider" />
    </Row>
);

export default function FixedLabelContainer({ children }) {
    const classes = useStyles();
    return <div className={classes.fixedLabelContainer}>{children}</div>;
}
